import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';

const Breadcrumb = ({ path, comName, categoryTitle }) => {
  const { i18n, t } = useTranslation();
  const language = i18n.language
  const categoryName = (comName === 'blogDetalis' && language === 'en') ? (path?.pathname?.split('/')[1]) : (comName === 'blogDetalis') ? (path?.pathname?.split('/')[2]) : (language === 'en') ? path?.pathname?.split('/')[2] : path?.pathname?.split('/')[3];


  const formattedStr = categoryName?.replace(/-/g, ' ');  // Replace all hyphens with spaces

  const capitalizedcategoryName = formattedStr?.split(' ')?.map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')


  const containsEncodedSpace = categoryName?.includes('%20');
  if (containsEncodedSpace) {
  } else {
  }
  const decodedCategoryName = categoryName?.replace(/%20/g, ' ');

  return (
    <div className="breadcrumb-sec">
      <div className="container">
        <p>
          {/* Home link */}
          <Link to="/">
            <i className="fa-solid fa-house" />
          </Link>
          <span>/</span>

          {
            path === 'allMusic' && (
              <>
                <Link to="/music">{t('bredcumb_music')}</Link> <span>/</span>
                <Link to="/music/all">{t('bredcumb_music_all')}</Link>
              </>
            )
          }

          {path === 'music' && (
            <>
              <Link to="/music">{t('bredcumb_music')}</Link>
            </>
          )}

          {path === 'licenses' && (
            <>
              <Link to="/licenses">{t('bredcumb_licences')}</Link>
            </>
          )}

          {path === 'about-us' && (
            <>
              <Link to="/about-us">{t('about_us')}</Link>
            </>
          )}
          {path === 'contact' && (
            <>
              <Link to="/contact">{t('bredcumb_Contact')} </Link>
            </>
          )}
          {path === 'bredcumb_backgroundPage' && (
            <>
              <Link >{t('bredcumb_backgroundPage')} </Link>
            </>
          )}

          {path === 'bredcumb_MusicFor' && (
            <>
              <Link >{t('bredcumb_MusicFor')} </Link>
            </>
          )}

          {path === 'bredcumb_NpCopyright' && (
            <>
              <Link >{t('bredcumb_NpCopyright')} </Link>
            </>
          )}

          {path === 'bredcumb_Licence' && (
            <>
              <Link >{t('bredcumb_Licence')} </Link>
            </>
          )}

          {path === 'bredcumb_Privacy' && (
            <>
              <Link >{t('bredcumb_Privacy')} </Link>
            </>
          )}
          {path === 'bredcumb_Termspage' && (
            <>
              <Link >{t('bredcumb_Termspage')} </Link>
            </>
          )}

          {path === 'bredcumb_Press' && (
            <>
              <Link >{t('bredcumb_Press')} </Link>
            </>
          )}




          {path === 'uses' && (
            <>
              <Link to="/uses">{t('bredcumb_Uses')}</Link>
            </>
          )}
          {comName === 'usesDetails' && (
            <>
              <Link>{t('bredcumb_Uses')}</Link>
              <span>/</span>
              <Link to={path?.pathname}> {capitalizedcategoryName}</Link>
            </>
          )}

          {comName === 'blogDetalis' && (
            <>
              <Link>{t('bredcumb_BlogDetails')}</Link>
              <span>/</span>
              <Link>{categoryTitle}</Link>
              <span>/</span>
              <Link to={path?.pathname}> {capitalizedcategoryName}</Link>

            </>
          )}
          {
            path === 'learnCategory' && (
              <>
                <Link>{t('bredcumb_BlogDetails')}</Link>
                <span>/</span>
                <Link>{categoryTitle}</Link>
              </>
            )
          }

          {path === 'learnBlog' && (
            <>
              <Link to="">{t('bredcumb_BlogDetails')}</Link>
            </>
          )
          }

          {path?.pathname && comName == 'musicAll' && (
            <>
              <Link to="/music">{t('bredcumb_music')}
              </Link> <span>/</span>
              <Link to={path?.pathname}>{capitalizedcategoryName?.endsWith('Royalty Free Music') ? capitalizedcategoryName : capitalizedcategoryName + " Royalty-Free Music"}</Link>
            </>
          )
          }

        </p>
      </div>
    </div>
  );
};

export default Breadcrumb;
